import CheckIcon from "../../../assets/svg/check-icon";
import {
  selectCrmLeadsFilters,
  setCrmLeadsLeadType,
  selectFilterState,
  setCommunicationsLeadType,
} from "../../../redux/slices/filterSlice";
import Button from "../../Button/Button";
import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTenantTypeOptions } from "../../../hooks/useTenantTypeOptions";

const LeadTypeFilter = ({
  onClose,
  isCommunication,
}: {
  onClose: () => void;
  isCommunication?: boolean;
}) => {
  const dispatch = useDispatch();
  const { options: tenantTypeOptions } = useTenantTypeOptions();
  const leadTypeOptions = useMemo(
    () => tenantTypeOptions.map((opt) => ({ value: opt.value, content: opt.label })),
    [tenantTypeOptions]
  );
  const crmLeadType = useSelector(selectCrmLeadsFilters)?.leadType;
  const filterState = useSelector(selectFilterState);
  const leadType = isCommunication
    ? filterState?.communications?.leadType
    : crmLeadType;

  const [selectedOption, setSelectedOption] = useState<{
    value: string;
    displayValue: string;
  }>({
    value: leadType.value as string,
    displayValue: leadType.displayValue as string,
  });

  const handleSelectOption = (option: {
    value: string;
    displayValue: string;
  }) => {
    setSelectedOption(option);
  };

  const handleApply = () => {
    if (selectedOption.value === leadType.value) {
      return;
    }
    if (isCommunication) {
      dispatch(
        setCommunicationsLeadType({
          value: selectedOption.value,
          displayValue: selectedOption.displayValue,
        })
      );
    } else {
      dispatch(
        setCrmLeadsLeadType({
          value: selectedOption.value,
          displayValue: selectedOption.displayValue,
        })
      );
    }

    onClose();
  };

  return (
    <div className="flex flex-col gap-1.5 mt-2 px-3">
      <h2 className="text-md  text-heading-text dark:text-heading-text-dk py-1.5">
        Select your preferred mode of communication.
      </h2>
      {leadTypeOptions?.map((option) => (
        <div
          key={option.value}
          onClick={() =>
            handleSelectOption({
              value: option.value,
              displayValue: option.content,
            })
          }
          className={`flex items-center justify-between border cursor-pointer text-md text-heading-text dark:text-heading-text-dk ${
            selectedOption.value === option.value
              ? "border-verba-blue dark:border-verba-blue-dk bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk"
              : "border-border-gray dark:border-border-gray-dk"
          } rounded-lg py-[13.5px] px-3`}
        >
          <div>{option.content}</div>
          {selectedOption.value === option.value && (
            <CheckIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
          )}
        </div>
      ))}
      <div className="flex justify-end gap-2 mt-4">
        <Button
          innerText="Cancel"
          onClick={onClose}
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
        />
        <Button
          onClick={handleApply}
          disabled={selectedOption.value === leadType.value}
          innerText="Apply"
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
        />
      </div>
    </div>
  );
};

export default LeadTypeFilter;

